export default __webpack_public_path__ + "static/toggler-rodrigo-e4bc3b3bc814d10b40ca1fa526d62bbd.jpg";